import { useQuery } from "@tanstack/react-query";
import TchrURL from "../../TchrURL";
import { useStytchSession, useStytch } from "@stytch/react";
import { checkResponseStatus } from "@/lib/utils/responseChecker";
import i18n from "i18next";

const useUnauthenticatedCheckoutSession = ({
  sessionId,
  enabled,
}: {
  sessionId: string;
  enabled: boolean;
}) => {
  const { session } = useStytchSession();
  const stytch = useStytch();

  return useQuery<string, Error, string>({
    queryKey: ["checkout", "session", "unauthenticated", sessionId],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.append("sessionId", sessionId);
      const url = new TchrURL("/payment/sessionstatus");
      url.search = searchParams.toString();
      const headers: HeadersInit = {};

      // Add auth header only if user is authenticated
      if (session) {
        const tokens = stytch.session.getTokens();
        if (tokens?.session_jwt) {
          headers.Authorization = `Bearer ${tokens.session_jwt}`;
        }
      }

      const response = await fetch(url, { headers });
      checkResponseStatus(
        response,
        i18n.getFixedT?.(null, ["errors"]) || (i18n.t.bind(i18n) as any),
        { context: "payment.sessionStatus" }
      );

      return response.json();
    },
    enabled: enabled && !!sessionId,
  });
};

export default useUnauthenticatedCheckoutSession;
